import { useContext } from 'react';
import { AppContext } from '../AppContext';

export const useAppProps = () => {
    const context = useContext(AppContext);

    if (context === undefined) {
        throw new Error('useAppProps must be used within a AppContextProvider');
    }

    return context;
};
